import { makeStyles } from 'tss-react/mui';

export default makeStyles()({
    header: {
        wordBreak: 'break-all',
        color: '#2D2D2D',
        fontSize: 28,
        fontWeight: 700,
        lineHeight: '42px',
        margin: 0
    },
    added: {
        background: '#E5F6ED'
    },
    removed: {
        background: '#FFEBED'
    }
});
